var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_83_4482)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    transform: "matrix(-1 0 0 1 153.674 3.5)",
    fill: "black",
    fillOpacity: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 153,
    height: 153,
    rx: 76.5,
    transform: "matrix(-1 0 0 1 156.674 3.5)",
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6593 43.6871C89.569 43.233 88.3739 43.0305 87.1683 42.9712L50.9766 42.9055C48.575 42.8911 46.266 43.831 44.5572 45.5186C42.8485 47.2061 41.8798 49.5032 41.8642 51.9047L41.7907 110.681C41.7719 112.457 42.2741 114.199 43.235 115.693C44.196 117.186 45.5736 118.365 47.1975 119.084C48.2878 119.539 49.4725 119.884 50.7724 119.835L87.0061 119.918C88.7614 119.907 90.4766 119.392 91.9481 118.435C93.4197 117.478 94.5858 116.118 95.3082 114.519C95.7868 113.488 96.0837 112.184 96.1604 110.937L96.0662 52.0906C96.1127 50.309 95.6219 48.5546 94.6576 47.0558C93.6932 45.557 92.3 44.3832 90.6593 43.6871ZM105.253 49.7657L105.135 90.8077L116.227 64.1789C117.153 61.9546 117.158 59.4532 116.241 57.2252C115.323 54.9972 113.558 53.225 111.333 52.2985M125.459 65.7608L109.686 103.628L130.112 83.2988C130.953 82.457 131.62 81.4575 132.074 80.3576C132.527 79.2577 132.76 78.079 132.757 76.8892C132.754 75.6993 132.516 74.5217 132.058 73.4239C131.599 72.3261 130.928 71.3297 130.083 70.4918M87.2183 51.9484L87.1064 111.053L50.7714 110.977L50.8658 51.9142",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_83_4482",
    x: -10.3262,
    y: -10.5,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_83_4482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_83_4482",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconLeft);
export default __webpack_public_path__ + "static/media/menu-icon-left.697bb5626b6a2f3c60acd90127c294d0.svg";
export { ForwardRef as ReactComponent };